import http from '../http-common';

/*
  Push notifications.

  These used to POST to fcm.googleapis.com directly, carrying the Firebase server
  key in an Authorization header:

      const { REACT_APP_FIREBASE_KEY } = process.env;
      headers: { Authorization: `key=${REACT_APP_FIREBASE_KEY}` }

  Anything named REACT_APP_* is inlined into the production bundle by CRA, so that
  key was served to every browser that loaded this app. An FCM server key can push
  to /topics/all - so anyone who opened devtools could send a notification to every
  user of the app.

  The backend now holds the key and does the sending. These go through the
  authenticated axios instance like every other call.

  The old key must be rotated in the Firebase console - it was public for as long
  as the portal was deployed, and removing it from here does not un-leak it.

  Both are fire-and-forget by design: a push is a side effect of something the user
  already did, and must not surface as a failure of that action.
*/

const send = (payload) =>
  http.post('/admin/sendPushNotification', payload).catch(() => { });

/* Broadcast to every device subscribed to the 'all' topic. */
export const sendNtfy = (title, body) => send({ title, body });

/* Send to one device, by its FCM registration token. */
export const sendNtfySingle = (title, body, token) => send({ title, body, token });
